<div>
  <app-generic-form title="Nuova Password">
    <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" form-content>
      <p class="text-muted small mb-3">
        Inserisci la nuova password per il tuo account.
      </p>

      @if (successMessage()) {
        <div class="alert alert-success" role="alert">
          {{ successMessage() }}
        </div>
      }

      @if (errorMessage()) {
        <div class="alert alert-danger" role="alert">
          {{ errorMessage() }}
        </div>
      }

      @if (token()) {
        <div class="mb-3">
          <label for="newPassword" class="form-label">Nuova Password</label>
          <input
            id="newPassword"
            type="password"
            formControlName="newPassword"
            class="form-control"
            [class.is-invalid]="resetPasswordForm.get('newPassword')?.invalid && resetPasswordForm.get('newPassword')?.touched"
            placeholder="Minimo 6 caratteri">
          @if (resetPasswordForm.get('newPassword')?.invalid && resetPasswordForm.get('newPassword')?.touched) {
            <div class="invalid-feedback">
              La password deve contenere almeno 6 caratteri.
            </div>
          }
        </div>

        <div class="mb-3">
          <label for="confirmPassword" class="form-label">Conferma Nuova Password</label>
          <input
            id="confirmPassword"
            type="password"
            formControlName="confirmPassword"
            class="form-control"
            [class.is-invalid]="(resetPasswordForm.get('confirmPassword')?.touched || resetPasswordForm.get('newPassword')?.touched) && resetPasswordForm.hasError('mismatch')"
            placeholder="Ripeti la password">
          @if ((resetPasswordForm.get('confirmPassword')?.touched || resetPasswordForm.get('newPassword')?.touched) && resetPasswordForm.hasError('mismatch')) {
            <div class="invalid-feedback d-block">
              Le password non coincidono.
            </div>
          }
        </div>

        <button
          type="submit"
          [disabled]="isLoading() || resetPasswordForm.invalid"
          class="btn btn-primary w-100 mt-3 d-inline-flex align-items-center justify-content-center"
          id="resetPasswordFormBtn">
          <i class="bi" [class.bi-hourglass-split]="isLoading()" [class.bi-check-circle]="!isLoading()" aria-hidden="true"></i>
          <span class="ms-1">{{ isLoading() ? 'Aggiornamento in corso...' : 'Reimposta Password' }}</span>
        </button>
      }

      <button
        class="btn btn-outline-secondary btn-sm w-100 mt-2 d-inline-flex align-items-center justify-content-center"
        type="button"
        id="backToLoginFromResetBtn"
        routerLink="/login">
        <i class="bi bi-arrow-left me-1" aria-hidden="true"></i>Torna al Login
      </button>
    </form>
  </app-generic-form>
</div>
